import { AsyncPipe, NgIf } from '@angular/common';
import { Component } from '@angular/core';

import { ConfigService } from '@dav-core/services/config.service';

@Component({
  selector: 'app-top-alert',
  templateUrl: './top-alert.component.html',
  styleUrls: ['./top-alert.component.scss'],
  standalone: true,
  imports: [NgIf, AsyncPipe],
})
export class TopAlertComponent {
  constructor(public configService: ConfigService) {}

  dismissError() {
    this.configService.hideErrorMessage();
  }

  dismissNewVersion() {
    this.configService.hideNewVersionMessage();
  }

  dismissWarning() {
    this.configService.hideWarningMessage();
  }
}
